import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import Logo from "./Logo";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="navbar">
      {/* Logo */}
      <Logo onClick={() => setIsOpen(false)} />

      {/* Hamburger / Close Icon */}
      <div className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "✖" : "☰"}
      </div>

      {/* Navigation Links */}
      <nav className={`nav-links ${isOpen ? "open" : ""}`}>
        <Link to="/home" onClick={() => setIsOpen(false)}>HOME</Link>
        <Link to="/about" onClick={() => setIsOpen(false)}>ABOUT US</Link>
        <Link to="/services" onClick={() => setIsOpen(false)}>PRODUCTS & SERVICES</Link>
        {/* <Link to="/blog" onClick={() => setIsOpen(false)}>BLOG</Link> */}
        <Link to="/contact" onClick={() => setIsOpen(false)}>CONTACT US</Link>
      </nav>

      {/* Contact Section */}
      <div className="contact-section">
        <div className="phone">
          <span className="phone-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
  <path d="M22 16.92v3a2 2 0 0 1-2.18 2
           19.79 19.79 0 0 1-8.63-3.07
           19.5 19.5 0 0 1-6-6
           19.79 19.79 0 0 1-3.07-8.67
           A2 2 0 0 1 4.11 2h3
           a2 2 0 0 1 2 1.72
           12.44 12.44 0 0 0 .67 2.81
           2 2 0 0 1-.45 2.11l-1.27 1.27
           a16 16 0 0 0 6 6l1.27-1.27
           a2 2 0 0 1 2.11-.45
           12.44 12.44 0 0 0 2.81.67
           A2 2 0 0 1 22 16.92z"/>
</svg>
</span>
          <div>
            <small>Contact Us Now</small>
            <p>08169405098</p>
          </div>
        </div>
        <Link to="/contact">
          <button className="quote-btn">GET A QUOTE</button>
        </Link>
      </div>
    </header>
  );
}

export default Header;
